export default __webpack_public_path__ + "img/road.1aa3d58a.png";